<template>
<div class="chapter">
<div class="inner_page">
<p class="chap3">P<span class="small">ART</span> I:</p>
<p class="chap3a">L<span class="small">ADY</span> K<span class="small">ILLERS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?1afce8fd